var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 297,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    strokeWidth: 50,
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "g1983"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    strokeWidth: 0.03403,
    fill: "#0000ff",
    ry: 62.32288,
    rx: 79.03719,
    cy: 134.22918,
    cx: -607.26785,
    id: "path31-6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    strokeWidth: 0.03201,
    fill: "#ffffff",
    d: "m-636.38799,94.23747l-2.04386,3.67224l7.51707,10.13011l-13.36906,-0.0278l-2.67776,3.79426l2.2924,2.88786l18.89664,0.41457l11.49666,15.74517l-22.86189,-0.03533l-8.91988,-12.35606l-5.29278,-0.05182l-2.11377,3.1187l6.78998,9.24632l-15.76363,0.09422l-2.667,3.50311l2.84624,3.54127l14.75155,0l-7.35038,8.24146l2.56842,4.10518l5.8018,0.06124l8.78904,-12.35983l23.14866,0.09422l-11.31265,14.35636l-18.11099,-0.06124l-3.09477,4.22531l2.79665,3.2539l12.91142,0.01084l-7.55292,10.32326l2.85281,4.05054l6.07125,0.01084l7.11021,-9.71177l5.35133,8.04124l5.79463,0.30151l2.9705,-3.93606l-8.50166,-12.08659l10.56524,-14.43975l9.8513,13.49001l-9.15945,12.3212l3.08043,4.23662l4.97076,-0.28266l6.49424,-8.79453l7.53261,10.32891l5.87768,0.0848l3.06012,-4.13816l-7.0899,-9.71742l11.50622,0.38159l3.23338,-3.80509l-2.82473,-3.99636l-17.52251,-0.26853l-10.92849,-14.2758l21.72375,0.04523l8.24297,12.33392l5.41406,-0.03345l3.04638,-3.76175l-6.6681,-8.58725l14.66671,0.04523l2.7602,-3.94501l-2.87969,-3.24118l-14.70913,0.00565l6.60178,-9.10452l-2.86535,-3.63173l-4.32073,0.03533l-9.78139,12.70562l-21.47103,-0.03533l11.35387,-15.51009l17.48308,0.10835l2.247,-3.42962l-2.18486,-3.34482l-12.37849,-0.23084l7.15024,-9.83049l-2.84205,-4.00342l-5.03647,0.36746l-7.22432,10.13011l-6.74039,-9.17942l-5.43975,0.18373l-2.17112,2.97124l8.9611,13.15882l-10.84306,14.72288l-11.81869,-15.85117l8.80995,-11.63245l-2.43639,-3.39665l-4.87158,-0.16017l-6.51635,8.39834l-7.03852,-9.93601l-5.99239,-0.09422l-0.00239,0.00565z",
    id: "rect2830-5"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "g3555"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    strokeWidth: 0.03403,
    fill: "#f2f2f2",
    ry: 62.32288,
    rx: 79.03719,
    cy: 134.22918,
    cx: -370.15626,
    id: "path31-6-7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    strokeWidth: 0.00198,
    fillRule: "evenodd",
    fill: "#0000ff",
    d: "m-346.7734,139.11654c0,9.90021 -10.481,17.9358 -23.38107,17.9358c-12.91142,0 -23.61826,-8.03747 -23.38107,-17.9358c0.31067,-13.27754 13.1725,-18.68579 23.38107,-33.94667c10.83708,14.76057 23.38107,24.04599 23.38107,33.94667z",
    id: "path2530"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "g3560"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    strokeWidth: 0.03403,
    fill: "#f2f2f2",
    ry: 62.32288,
    rx: 79.03719,
    cy: 134.22918,
    cx: -133.04466,
    id: "path31-6-7-5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    strokeWidth: 0.00198,
    fillRule: "evenodd",
    fill: "#0000ff",
    d: "m-94.39107,146.19956c0,9.90021 -10.4816,17.9358 -23.38107,17.9358c-12.91201,0 -23.61826,-8.03747 -23.38107,-17.9358c0.31067,-13.27754 13.1725,-18.68579 23.38107,-33.94667c10.83649,14.76057 23.38107,24.04599 23.38107,33.94667z",
    opacity: 0.69855,
    id: "path2530-6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    strokeWidth: 0.00147,
    fillRule: "evenodd",
    fill: "#0000ff",
    d: "m-147.35052,115.22601c0,7.32846 -7.75844,13.27707 -17.30743,13.27707c-9.55795,0 -17.48368,-5.95002 -17.30803,-13.27707c0.22703,-9.8286 9.75092,-13.83203 17.30803,-25.12905c8.02191,10.92674 17.30743,17.80012 17.30743,25.12905z",
    opacity: 0.69855,
    id: "path2530-6-1"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "g3573"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "g3566"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    strokeWidth: 0.03403,
    fill: "#f2f2f2",
    ry: 62.32288,
    rx: 79.03719,
    cy: 134.22918,
    cx: 104.06693,
    id: "path31-6-7-5-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    strokeWidth: 0.00198,
    fillRule: "evenodd",
    fill: "#0000ff",
    d: "m127.44979,159.65753c0,9.89974 -10.481,17.93533 -23.38107,17.93533c-12.91142,0 -23.61826,-8.03747 -23.38107,-17.93533c0.31067,-13.27801 13.1725,-18.68626 23.38107,-33.94714c10.83708,14.76057 23.38107,24.04646 23.38107,33.94714z",
    opacity: 0.69855,
    id: "path2530-6-7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    strokeWidth: 0.00147,
    fillRule: "evenodd",
    fill: "#0000ff",
    d: "m90.65963,113.80941c0,7.32846 -7.75904,13.27707 -17.30803,13.27707c-9.55795,0 -17.48308,-5.95002 -17.30803,-13.27707c0.22703,-9.8286 9.75152,-13.8325 17.30803,-25.12905c8.02191,10.92674 17.30803,17.80012 17.30803,25.12905z",
    opacity: 0.69855,
    id: "path2530-6-1-0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    strokeWidth: 0.00095,
    fillRule: "evenodd",
    fill: "#0000ff",
    d: "m144.66521,120.83024c0,4.75672 -4.94805,8.61787 -11.03782,8.61787c-6.09575,0 -11.15014,-3.86209 -11.03842,-8.61787c0.14339,-6.38013 6.21882,-8.97873 11.03842,-16.31144c5.11593,7.09244 11.03782,11.55378 11.03782,16.31144z",
    opacity: 0.69855,
    id: "path2530-6-1-0-9"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "g7384"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    strokeWidth: 0.03403,
    fill: "#0000ff",
    ry: 62.32288,
    rx: 79.03719,
    cy: 134.22914,
    cx: -844.37944,
    id: "path31"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    strokeWidth: 0.06615,
    fill: "#ffffff",
    ry: 12.46457,
    rx: 15.80744,
    cy: 160.86039,
    cx: -844.37944,
    id: "path277"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    strokeWidth: 0.29581,
    fill: "#ffffff",
    y: 98.5375,
    x: -852.28318,
    height: 62.32286,
    width: 15.80744,
    id: "rect406"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    strokeWidth: 0.13609,
    fill: "#0000ff",
    y: 135.93123,
    x: -849.15902,
    height: 21.81299,
    width: 9.55914,
    id: "rect406-3"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "null",
    strokeWidth: 0.39687,
    fill: "#0000ff",
    r: 4.77156,
    cy: 160.86039,
    cx: -844.37944,
    id: "path532"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "null",
    strokeWidth: 0.26458,
    fill: "#ffffff",
    r: 3.18104,
    cy: 99.31454,
    cx: -844.37944,
    id: "path7264"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater3);
export default __webpack_public_path__ + "static/media/water_3.84be0ba0f23bc8108fe5223953553bc3.svg";
export { ForwardRef as ReactComponent };